import { Capacitor } from '@capacitor/core';

/** True when running inside a Capacitor native shell (Android/iOS). */
export function isCapacitorNative(): boolean {
  try {
    if (Capacitor.isNativePlatform()) return true;
    const platform = Capacitor.getPlatform();
    if (platform && platform !== 'web') return true;
  } catch {
    /* ignore */
  }

  // Capacitor serves the bundled app at http(s)://localhost (no dev-server port).
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    if ((protocol === 'https:' || protocol === 'http:') && hostname === 'localhost' && port === '') {
      return true;
    }
  }
  return false;
}
